import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { api } from "@/utils/api";

import FirstLevelMenu from "@/react-components/SiderBar/FirstLevelMenu";
import MobileFirstLevelMenu from "@/react-components/SiderBar/MobileFirstLevelMenu";
import SecondLevelMenu from "@/react-components/SiderBar/SecondLevelMenu";
import MobileSecondLevelMenu from "@/react-components/SiderBar/MobileSecondLevelMenu";
import MobileAccountItem from "@/react-components/SiderBar/MobileAccountItem";
import config from "@/utils/config";
import i18n from "i18next";
import { eventEnum, routerEnum, modeEnum, BMMenuStateEnum } from "@/utils/enum";
import url from "@/utils/url";
import { preventClickEvent, isEmpty, parse } from "@/utils";
import { urlFromEnum, urlMatchEnum } from "../../utils/enum";

class SiderBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // PCメニュー折り畳み状態
      isMenuFold: false,
      // SPメニューオープン状態
      isMenuOpen: false,
      // メニュー一覧
      menuList: [],
      // ボトムメニュー
      subMenuList: [],
      // 選択したアイテム
      selectedItem: undefined,
      // 二級メニューが表示されますか
      isShowSecondary: false,
      paymentServiceStarted: false
    };
  }

  componentDidMount() {
    this.fetchTime()
      .then(() => this.updateMenuSelected());
    this.disableEvent();
    config.eventEmitter.addListener(eventEnum.toggleMenu, this.toggleMenuOpen);
  }

  componentWillUnmount() {
    config.eventEmitter.removeListener(
      eventEnum.toggleMenu,
      this.toggleMenuOpen
    );
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps?.bmServiceStatus !== this.props?.bmServiceStatus ||
      prevProps?.menuAuthorityInfo !== this.props?.menuAuthorityInfo ||
      // 課金-ADD-START
      prevProps?.contractInfo?.corporationBmServiceAvailabilityFlag !==
        this.props?.contractInfo?.corporationBmServiceAvailabilityFlag
      // 課金-ADD-END
    ) {
      const routerList = this.getRouterList();
      const { paymentServiceStarted } = this.state;
      this.setState(
        {
          menuList: routerList.filter(
            (item) => item.type === routerEnum.sideBarTop
          ),
          subMenuList: paymentServiceStarted
          ? routerList.filter(
            (item) => item.type === routerEnum.sideBarBottom
          )
          :routerList.filter(
            (item) => item.type === routerEnum.sideBarBottom && item.path !== url.payment
          ),
        },
        () => {
          this.updateMenuSelected();
        }
      );
    } else if (
      prevProps?.menuBadgeInfo !== this.props?.menuBadgeInfo ||
      prevProps?.BMMenuState !== this.props?.BMMenuState
    ) {
      const routerList = this.getRouterList();
      const { menuList, subMenuList } = this.state;
      const { paymentServiceStarted } = this.state;
      const newMenuList = routerList.filter(
        (item) => item.type === routerEnum.sideBarTop
      );
      const newSubMenuList = paymentServiceStarted
          ? routerList.filter(
            (item) => item.type === routerEnum.sideBarBottom
          )
          :routerList.filter(
            (item) => item.type === routerEnum.sideBarBottom && item.path !== url.payment
          );
      const actived =
        menuList.find((item) => item.active) ||
        subMenuList.find((item) => item.active);
      const menu =
        newMenuList.find((item) => item.path === actived.path) ||
        newSubMenuList.find((item) => item.path === actived.path);
      if (menu) {
        menu.active = true;
        if (menu.secondary) {
          menu.children = actived.children;
        }
      }
      this.setState({
        menuList: newMenuList,
        subMenuList: newSubMenuList,
      });
    } else if (
      prevProps?.location?.pathname !== this.props?.location?.pathname
    ) {
      const prevPathName = prevProps?.location?.pathname;
      const locationPathName = this.props?.location?.pathname;
      const bmMatchFlg =
        prevPathName.indexOf(urlMatchEnum.businessMatching) !== -1 &&
        locationPathName.indexOf(urlMatchEnum.businessMatching) === -1;

      const from = parse("from", this.props?.location?.search);
      if (
        from === urlFromEnum.search ||
        from === urlFromEnum.notification ||
        from === urlFromEnum.InnerTab ||
        bmMatchFlg
      ) {
        this.updateMenuSelected();
      } else if (from === "homeBm") {
        this.updateMenuSelected("/business-matching/search/results/");
      }
    }
  }

  fetchTime = async () => {   
    const serviceStartDate = new Date(i18n.t("TCCs0018_lp_payment_service_start_datetime"));
    await api.common
      .getTime()
      .then((response) => {
        const paymentServiceStarted = new Date(response) >= serviceStartDate;
        this.setState({ paymentServiceStarted });
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  // get Router list
  getRouterList = () => {
    return config.router(
      this.props?.bmServiceStatus,
      this.props?.menuAuthorityInfo,
      this.props?.menuBadgeInfo,
      this.props?.BMMenuState,
      // 課金-ADD-START
      this.props?.contractInfo?.corporationBmServiceAvailabilityFlag
      // 課金-ADD-END
    );
  };

  // EEモードを無効にする
  disableEvent = () => {
    const { mode } = this.props;
    if (mode === modeEnum.pageEditing || mode === modeEnum.preview) {
      preventClickEvent("sideBar");
    }
  };

  // 更新メニュー
  updateMenuSelected = (selectedPathname) => {
    const {
      history: {
        location: { pathname },
      },
    } = this.props;    
    const routerList = this.getRouterList();
    const menuList = routerList.filter(
      (item) => item.type === routerEnum.sideBarTop
    );
    const { paymentServiceStarted } = this.state;
    const subMenuList = paymentServiceStarted
    ?routerList.filter(
      (item) => item.type === routerEnum.sideBarBottom
    )
    :routerList.filter(
      (item) => item.type === routerEnum.sideBarBottom && item.path !== url.payment
    );
    let result1 = false;
    let result2 = false;
    if (selectedPathname) {
      result1 = this.loopMenuSelected(selectedPathname, menuList, true);
      result2 = this.loopMenuSelected(selectedPathname, subMenuList, true);
    } else {
      result1 = this.loopMenuSelected(pathname, menuList, true);
      result2 = this.loopMenuSelected(pathname, subMenuList, true);
    }
    if (!result1 && !result2) {
      menuList[0].active = true;
    }
    this.setState({ menuList, subMenuList }, () => {
      this.updateShowSecondary();
    });
  };

  // 二級メニューは展開されますか
  updateShowSecondary = () => {
    const { menuList } = this.state;
    const results = menuList.filter((item) => item.active && item.secondary);
    if (results.length > 0) {
      this.setState({
        selectedItem: results[0],
        isShowSecondary: true,
        isMenuFold: false,
      });
      const { BMMenuState } = this.props;
      if (BMMenuState === BMMenuStateEnum.allowSetting) {
        const {
          history: { push },
        } = this.props;
        push(url.businessMatchingActionSettings);
      }
    } else {
      this.setState({ isShowSecondary: false });
    }
  };

  // 巡回と選択
  loopMenuSelected = (pathName, list, root = false) => {
    let selected = false;
    if (!isEmpty(pathName)) {
      for (const item of list) {
        let active = false;
        if (!item.disabled) {
          const condition1 =
            pathName === item.path || pathName === `${item.path}/`;
          const condition2 =
            pathName.indexOf(item.path) === 0 ||
            pathName.indexOf(item.match) === 0;
          if (item.path === url.home && condition1) {
            active = true;
          }
          if (
            !root &&
            (item.path === url.businessMatching ||
              item.path === url.businessMatchingSettings) &&
            condition1
          ) {
            active = true;
          }
          if (
            item.path !== url.home &&
            (root ||
              (item.path !== url.businessMatching &&
                item.path !== url.businessMatchingSettings)) &&
            (condition1 || condition2)
          ) {
            active = true;
          }
          if (item?.children?.length > 0) {
            const childrenActive = this.loopMenuSelected(
              pathName,
              item.children
            );
            active = childrenActive || active;
            if (!item.path && item.open !== undefined) {
              item.open = item.open || active;
            }
            if (root && item.path === url.businessMatching && !childrenActive) {
              item.children[0].active = active;
            }
          }
        }
        item.active = active;
        active && (selected = active);
        if (active) {
          break;
        }
      }
    }
    return selected;
  };

  // PCメニュー折り畳み/展開
  toggleMenuFold = () => {
    const { isMenuFold } = this.state;
    this.setState({
      isMenuFold: !isMenuFold,
    });
  };

  // SPメニューオープン/クローズ
  toggleMenuOpen = () => {
    const { isMenuOpen } = this.state;
    this.setState({
      isMenuOpen: !isMenuOpen,
    });
  };

  // メニューをクリック
  click = (item) => {
    const { isMenuOpen, isShowSecondary, isMenuFold } = this.state;
    if (isMenuOpen && !(item.secondary && !isShowSecondary)) {
      this.toggleMenuOpen();
    }
    if (item.secondary && isMenuFold) {
      this.toggleMenuFold();
    }
    this.updateShowSecondary();
  };

  // サブメニューをクリックして選択
  subItemClick = (item) => {
    const { isMenuOpen } = this.state;
    if (isMenuOpen) {
      this.toggleMenuOpen();
    }
  };

  dismiss = () => {
    this.setState({ isShowSecondary: false });
    const {
      history: { replace },
    } = this.props;
    replace(url.home);
    this.updateMenuSelected();
  };

  render() {
    const {
      menuList,
      subMenuList,
      isMenuFold,
      isMenuOpen,
      isShowSecondary,
      selectedItem,
    } = this.state;
    return (
      <React.Fragment>
        <div
          id="sideBar"
          className={`flex-column menu flex-when-pc hide-scroll-bar ${
            isMenuFold ? "folded" : ""
          }`}
        >
          <div className="align-self-center logo" onClick={this.dismiss}>
            <span
              className={`logo-img ${config.isTest ? "test-logo-img" : ""}`}
            />
          </div>
          {isShowSecondary ? (
            <SecondLevelMenu
              menu={selectedItem}
              click={this.click}
              dismiss={this.dismiss}
              backText="Trynibusホーム"
            />
          ) : (
            <FirstLevelMenu
              menuList={menuList}
              subMenuList={subMenuList}
              click={this.click}
              subItemClick={this.subItemClick}
              toggleMenuFold={this.toggleMenuFold}
            />
          )}
        </div>
        <div
          className={`flex-column sp-menu flex-when-sp ${
            isMenuOpen ? "open" : ""
          }`}
        >
          <div className="sp-menu-content hide-scroll-bar">
            <div className="flex-row-vertical-center sp-menu-header">
              <div
                className="flex-row-center sp-menu-close-button"
                onClick={this.toggleMenuOpen}
                tabIndex="0"
              >
                <i />
              </div>
            </div>
            {isShowSecondary ? (
              <MobileSecondLevelMenu
                menu={selectedItem}
                click={this.click}
                dismiss={this.dismiss}
              />
            ) : (
              <React.Fragment>
                <MobileAccountItem toggleMenuOpen={this.toggleMenuOpen} />
                <div className="sp-menu-divider" />
                <MobileFirstLevelMenu
                  menuList={menuList}
                  subMenuList={subMenuList}
                  click={this.click}
                  subItemClick={this.subItemClick}
                />
              </React.Fragment>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    mode: state?.config?.mode,
    bmServiceStatus: state?.user?.bmServiceStatus,
    menuAuthorityInfo: state?.user?.menuAuthorityInfo,
    menuBadgeInfo: state?.user?.menuBadgeInfo,
    BMMenuState: state?.user?.BMMenuState,
    // 課金-ADD-START
    contractInfo: state?.user?.contractInfo,
    // 課金-ADD-END
  };
};

export default withRouter(connect(mapStateToProps)(SiderBar));
